import React, { useEffect } from "react";
import bg_image from "../assets/why_bed_3.jpg";
import why_men from "../assets/why_buy_man.png";
import whybt from "../assets/whybt.jpg";
import layer from "../assets/why_buy_layer_2.png";
import waves from "../assets/vawes.png";
import icon_1 from "../assets/why_buy_icon_1.png";
import icon_2 from "../assets/why_buy_icon_2.png";
import icon_3 from "../assets/why_buy_icon_3.png";
import icon_4 from "../assets/why_buy_icon_4.png";
import icon_5 from "../assets/why_buy_icon_5.png";
import icon_6 from "../assets/why_buy_icon_6.png";
const WhyBuyLatex = () => {
  const benefits = [
    {
      id: "1",
      icon: icon_1,
      title: "Toxin-free comfort",
      desc: `Natural latex comes from the sap
of rubber trees. It is free from harmful
chemicals, making your sleep environment
cleaner and safer.
`,
    },
    {
      id: "2",
      icon: icon_2,
      title: "Hypoallergenic by nature",
      desc: `Latex naturally resists dust mites, mold,
and bacteria. It helps keep your mattress
fresh and is a great choice for sensitive
skin and allergies.
`,
    },
    {
      id: "3",
      icon: icon_3,
      title: "Breathable and cool",
      desc: `Its open cell-structure allows air
to flow easily. This keeps the surface cool
and comfortable, even in warm
and humid conditions.
`,
    },
    {
      id: "4",
      icon: icon_4,
      title: "Supports your body naturally",
      desc: `Latex gently adapts to your body’s shape.
It relieves pressure and keeps your
spine aligned, so you wake up
without stiffness.
`,
    },
    {
      id: "5",
      icon: icon_5,
      title: "Responsive and long-lasting",
      desc: `Latex has a natural bounce that quickly
returns to shape. It does not sag easily
and stays supportive for years.
`,
    },
    {
      id: "6",
      icon: icon_6,
      title: "A better choice, in every way",
      desc: `Choosing natural latex is not just about
better sleep. It is about choosing materials
that are safer, more durable, and kinder
to the environment.
`,
    },
  ];

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
      {/* Top Banner Part */}

      <div className="w-full  font-lexend lg:block hidden  relative overflow-hidden">
        <div className="w-full -z-30">
          <img
            src={bg_image}
            alt=""
            className="3xl:h-[1080px] xl:h-[1090px] lg:h-[730px]  "
          />
        </div>
        <div className="grid lg:grid-cols-2 grid-cols-1 z-10 xl:gap-8 sm:gap-4 w-full absolute top-0 xl:pt-40 pt-32 left-1/2 -translate-x-1/2 -translate-y- md:max-w-[80%] xl:max-w-[78rem] 2xl:max-w-[80rem] 3xl:max-w-[88rem] mx-auto">
          <div className="2xl:pt-28 xl:pt-24 lg:px-0 px-8 xs:px-4">
            <h1 className="2xl:text-6xl xl:text-5xl lg:text-4xl text-3xl xs:text-2xl 2xl:leading-[64px]  text-[#3a683f] font-extralight uppercase">
              Why buy a natural <br /> latex mattress?{" "}
            </h1>
            <h2 className="2xl:mt-28 xl:mt-20 mt-4 2xl:text-5xl lg:text-4xl text-2xl xs:text-xl text-[#3a683f] font-extralight  ">
              These days, choosing <br />a mattress isn’t easy.
            </h2>
            <p className="text-lg xs:text-sm text-[#6d6d6d] font-light 2xl:pe-20 xl:pe-16  mt-2 xl:mt-14">
              There are too many options, too many claims, and very little
              clarity. We simply rely on how it feels after lying on a mattress
              for a few minutes, without really thinking about what we are
              sleeping on and how it affects our health - and the planet - over
              time.
            </p>
            <p className="text-lg xs:text-sm text-[#6d6d6d] font-light 2xl:pe-20 xl:pe-16 lg:pb-5 xl:mt-8">
              Most mattresses are mass-manufactured, using synthetic materials
              and chemicals. What are your options if you believe in conscious
              living? Most people end up choosing what feels comfortable over
              what is responsible for the planet. But, what if you didn’t have
              to choose? A natural latex mattress brings together the best of
              both worlds comfort and sustainability.
            </p>
          </div>
          <div className="ps-14 ">
            <img src={why_men} className=" h-full z-10" alt="" />
            <img src={layer} alt="" className="absolute top-0 left-1/3 -z-20" />
          </div>
        </div>
      </div>

      <div className="w-full pt-5 bg-white  font-lexend lg:hidden block   relative overflow-hidden">
        <div className="top-0 absolute w-full h-full flex justify-center  pt-14  z-10">
          <div className="w-4/5 xl:w-11/12 2xl:w-[80rem] 3xl:w-3/4  mx-auto font-lexend sm:pt-8 pt-20  ">
            <h1 className=" sm:text-2xl xxs:text-xl text-4xl uppercase text-[#3a683f] font-extralight  xxs:pt-0 pt-5 leading-tight ">
              8 Why buy a natural <br />
              latex mattress?
            </h1>
          </div>
        </div>
        <img src={whybt} alt="" className="" />
        <div className=" p-6 font-lexend  bg-[#dcebdc]">
          <h2 className=" text-2xl xs:text-xl text-[#3a683f] font-extralight  ">
            These days, choosing <br />a mattress isn’t easy.
          </h2>
          <p className="text-lg xs:text-sm text-[#6d6d6d] font-light mt-2">
            There are too many options, too many claims, and very little
            clarity. We simply rely on how it feels after lying on a mattress
            for a few minutes, without really thinking about what we are
            sleeping on and how it affects our health - and the planet - over
            time.
          </p>
          <p className="text-lg xs:text-sm text-[#6d6d6d] font-light mt-2 ">
            Most mattresses are mass-manufactured, using synthetic materials and
            chemicals. What are your options if you believe in conscious living?
            Most people end up choosing what feels comfortable over what is
            responsible for the planet. But, what if you didn’t have to choose?
            A natural latex mattress brings together the best of both worlds
            comfort and sustainability.
          </p>
        </div>
      </div>
      <div className="w-full bg-[#3a683f]">
        <div className="w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[88rem] 2xl:px-0 lg:px-8 md:px-0 px-8  xs:px-4 mx-auto">
          <div className="flex justify-between items-end  overflow-hidden">
            <div>
              <h3 className="text-6xl xl:mt-0 mt-8 md:block hidden text-[#f4e391] font-light leading-[64px]">
                Benefits of <br />
                natural latex mattress
              </h3>
              <h3 className="text-4xl xs:text-2xl mt-8 md:hidden block text-[#f4e391] font-light ">
                Benefits of natural latex mattress
              </h3>
            </div>
            <div className="h-52 xl:block hidden w-[450px] relative overflow-hidden">
              <img
                src={waves}
                alt=""
                className="absolute right-0 -top-2 scale-150"
              />
            </div>
          </div>
          <div className="pt-10 xl:pb-40 md:pb-20 pb-10  grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 md:gap-8 gap-5 ">
            {benefits.map((item, index) => (
              <div
                key={index * Math.random(4548, 5555)}
                className="bg-[#4e8753] xl:py-14 xl:px-10 md:p-4 p-8 text-center"
              >
                <div className="flex justify-center font-lexend flex-col gap-4 items-center">
                  <img src={item.icon} alt="" className="md:w-auto w-24" />
                  <h4 className="text-[#f4e391] sm:text-xl xs:text-lg text-2xl font-semibold sm:mt-2 mt-4">
                    {item.title}
                  </h4>
                  <p className="text-center text-white text-lg xs:text-sm leading-[20px] xl:px-6 font-light">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default WhyBuyLatex;
